module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "testimonialsView"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('mu-card', {
    attrs: {
      "id": "addTestimonials"
    }
  }, [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle blueTitle",
      "title": _vm.cardTitle,
      "subTitle": _vm.cardSubTitle
    }
  }), _vm._v(" "), _c('mu-card-text', [_c('mu-row', [_c('mu-col', {
    attrs: {
      "desktop": "50"
    }
  }, [_c('form', {
    attrs: {
      "name": "submitTestimonialForm"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitTestimonial.apply(null, arguments)
      }
    }
  }, [_c('mu-row', {
    staticClass: "progressImages"
  }, [_c('mu-col', {
    attrs: {
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "beforeImage"
    },
    on: {
      "click": function($event) {
        return _vm.openImage('beforeImage')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.progressImage.before),
      expression: "!progressImage.before"
    }],
    staticClass: "instructions"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cloud_upload",
      "size": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelBeforePhoto'))
    }
  }), _vm._v(" "), _c('vue-base64-file-upload', {
    ref: "beforeImage",
    staticClass: "base64Upload",
    attrs: {
      "disable-preview": "",
      "placeholder": "Before image",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoadBefore
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progressImage.before),
      expression: "progressImage.before"
    }],
    staticClass: "imagePreview",
    style: ('background-image: url(' + _vm.progressImage.before + ')')
  })])]), _vm._v(" "), _c('mu-col', {
    attrs: {
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('div', {
    staticClass: "image",
    attrs: {
      "id": "afterImage"
    },
    on: {
      "click": function($event) {
        return _vm.openImage('afterImage')
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.progressImage.after),
      expression: "!progressImage.after"
    }],
    staticClass: "instructions"
  }, [_c('mu-icon', {
    attrs: {
      "value": "cloud_upload",
      "size": 40
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "label",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.labelAfterPhoto'))
    }
  }), _vm._v(" "), _c('vue-base64-file-upload', {
    ref: "afterImage",
    staticClass: "base64Upload",
    attrs: {
      "disable-preview": "",
      "placeholder": "After image",
      "accept": "image/png,image/jpeg",
      "max-size": _vm.maxSize
    },
    on: {
      "size-exceeded": _vm.onSizeExceeded,
      "load": _vm.onLoadAfter
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.progressImage.after),
      expression: "progressImage.after"
    }],
    staticClass: "imagePreview",
    style: ('background-image: url(' + _vm.progressImage.after + ')')
  })])])], 1), _vm._v(" "), _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      key: 'question-' + index,
      staticClass: "question"
    }, [(question.type == 'textarea') ? _c('mu-text-field', {
      directives: [{
        name: "validate",
        rawName: "v-validate"
      }],
      attrs: {
        "label": question.question,
        "rows": 3,
        "hintText": question.question_hint,
        "multiLine": "",
        "fullWidth": "",
        "data-vv-rules": 'required'
      },
      model: {
        value: (question.answer),
        callback: function($$v) {
          _vm.$set(question, "answer", $$v)
        },
        expression: "question.answer"
      }
    }) : _vm._e(), _vm._v(" "), (question.type == 'tel') ? _c('mu-text-field', {
      attrs: {
        "type": "tel",
        "label": question.question,
        "hintText": question.question_hint,
        "fullWidth": ""
      },
      model: {
        value: (question.answer),
        callback: function($$v) {
          _vm.$set(question, "answer", $$v)
        },
        expression: "question.answer"
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "terms"
  }, [_c('mu-checkbox', {
    model: {
      value: (_vm.terms.agreed),
      callback: function($$v) {
        _vm.$set(_vm.terms, "agreed", $$v)
      },
      expression: "terms.agreed"
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": function($event) {
        _vm.terms.agreed = !_vm.terms.agreed
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('message.registerTestimonialConcent')) + " "), _c('a', {
    attrs: {
      "href": (_vm.siteUrl + "terms")
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('message.registerTermsAndCondtions'))
    }
  }), _vm._v(" " + _vm._s(_vm.$t('message.registerTestimonialExplain')))])], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "submitBtn",
    attrs: {
      "type": "button",
      "label": _vm.isSubmitting ? _vm.$t('message.savingText') : _vm.$t('message.submitText'),
      "secondary": "",
      "disabled": _vm.isSubmitting
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitTestimonial.apply(null, arguments)
      }
    }
  })], 2)])], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d9f981d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Testimonials/Testimonials.vue
// module id = 3297
// module chunks = 1